import { P3 } from '@/lib/shared/components/Typography';

import cn from 'clsx';
import { useTranslation } from 'next-i18next';

import styles from './empty-state.module.scss';

export const CatalogUnavailableState = () => {
  const { t } = useTranslation('index');

  return (
    <div className={styles.emptyState} role="status" aria-live="polite">
      <div className={cn(styles.container, styles.emptyState__info)}>
        <P3 className={styles.emptyState__text}>
          {t('catalog.unavailableTitle')}
        </P3>
        <P3 className={styles.emptyState__text}>
          {t('catalog.unavailableDescription')}
        </P3>
      </div>
    </div>
  );
};
